//import Lnb from './Lnb.vue';
import ScpmTitle from './ScpmTitle.vue';
import ScpmSubTitle from './ScpmSubTitle.vue';
import ScpmDivider from './ScpmDivider.vue';
import ScpmSearch from './ScpmSearch.vue';
import ScpmTableSegment from './ScpmTableSegment.vue';
import ScpmTableSegmentV2 from './ScpmTableSegmentV2.vue';
import ScpmGaugeBar from './ScpmGaugeBar.vue';
import ScpmMethodSelect from './ScpmMethodSelect.vue';
import ScpmTagDropdown from './ScpmTagDropdown.vue';
import ScpmStatsDropdown from './ScpmStatsDropdown.vue';
import ScpmTreeDropdown from './ScpmTreeDropdown.vue';
import ScpmTreeDropdownV3 from './ScpmTreeDropdownV3.vue';
import ScpmAccordionItem from './ScpmAccordionItem.vue';
import ScpmDateRange from './ScpmDateRange.vue';
import ScpmPopover from './ScpmPopover.vue';
import ScpmDropDownV3 from './ScpmDropDownV3.vue';
import ScpmSelectBox from './ScpmSelectBox.vue';
import ScpmDateRangePicker from './ScpmDateRangePicker.vue';
import ScpmDateTimePicker from './ScpmDateTimePicker';
import ScpmTimePicker from './ScpmTimePicker';
import ScpmMoreActions from './ScpmMoreActions';
import ScpmEnergeBarIcon from './ScpmEnergeBarIcon.vue';
import ScpmChartDetail from './ScpmChartDetail.vue';
import ScpmMoreActionTeleport from './ScpmMoreActionTeleport.vue';
import ScpmTargetDetail from './ScpmTargetDetail.vue';
import ScpmTreeCheckboxDropdown from './ScpmTreeCheckboxDropdown.vue';
import ScpmPagination from './ScpmPagination.vue';
import ScpmRenderHtml from './ScpmRenderHtml.vue';
import ScpmInsightChartPopup from '@/containers/components/chart/PopUp/ScpmInsightChartPopup.vue';
export default {
  // install(Vue) {
  //   Vue.component(Lnb.name, Lnb);
  // },
  install(Vue) {
    Vue.component(ScpmTitle.name, ScpmTitle);
    Vue.component(ScpmSubTitle.name, ScpmSubTitle);
    Vue.component(ScpmDivider.name, ScpmDivider);
    Vue.component(ScpmSearch.name, ScpmSearch);
    Vue.component(ScpmTableSegment.name, ScpmTableSegment);
    Vue.component(ScpmTableSegmentV2.name, ScpmTableSegmentV2);
    Vue.component(ScpmGaugeBar.name, ScpmGaugeBar);
    Vue.component(ScpmMethodSelect.name, ScpmMethodSelect);
    Vue.component(ScpmTagDropdown.name, ScpmTagDropdown);
    Vue.component(ScpmStatsDropdown.name, ScpmStatsDropdown);
    Vue.component(ScpmTreeDropdown.name, ScpmTreeDropdown);
    Vue.component(ScpmTreeDropdownV3.name, ScpmTreeDropdownV3);
    Vue.component(ScpmAccordionItem.name, ScpmAccordionItem);
    Vue.component(ScpmDateRange.name, ScpmDateRange);
    Vue.component(ScpmDateRangePicker.name, ScpmDateRangePicker);
    Vue.component(ScpmDateTimePicker.name, ScpmDateTimePicker);
    Vue.component(ScpmTimePicker.name, ScpmTimePicker);
    Vue.component(ScpmPopover.name, ScpmPopover);
    Vue.component('scpm-more-actions', ScpmMoreActions);
    Vue.component(ScpmDropDownV3.name, ScpmDropDownV3);
    Vue.component('scpm-energe-bar', ScpmEnergeBarIcon);
    Vue.component('scpm-chart-detail', ScpmChartDetail);
    Vue.component('scpm-more-action-teleport', ScpmMoreActionTeleport);
    Vue.component('scpm-target-detail', ScpmTargetDetail);
    Vue.component(ScpmTreeCheckboxDropdown.name, ScpmTreeCheckboxDropdown);
    Vue.component(ScpmSelectBox.name, ScpmSelectBox);
    Vue.component('scpm-pagination', ScpmPagination);
    Vue.component('scpm-render-html', ScpmRenderHtml);
    Vue.component('scpm-insight-chart-popup', ScpmInsightChartPopup);
  }
};
